import React, { useState, useEffect } from "react";
import "./FAQContent.css";
import AOS from "aos";
import "aos/dist/aos.css";

function FAQContent() {
  useEffect(() => {
    AOS.init({ duration: 800 });
  }, []);
  return (
    <>
      <div className="main-banner">
        <img
          src={process.env.PUBLIC_URL + "/images/FAQ/faq-banner.png"}
          // src="images/FAQ/faq-banner.png"
          alt="banner"
          className="banner-img"
        />
      </div>
      <div className="faq-sec">
        <div className="faq-wrap" data-aos="zoom-in-up">
          <h2 className="faq-head">Get all your queries answered</h2>
          <p>
            Welcome to our Frequently Asked Questions (FAQ) section, a
            comprehensive resource designed to address common queries and
            provide clarity on various aspects of our platform. Explore this
            curated compilation of information to gain insights into key
            features, usage guidelines, and additional details.
          </p>
          <div class="accordion" id="accordionExample">
            <div class="accordion-item">
              <h2 class="accordion-header" id="headingOne">
                <button
                  class="accordion-button"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseOne"
                  aria-expanded="true"
                  aria-controls="collapseOne"
                >
                  What is the benefit of this program?
                </button>
              </h2>
              <div
                id="collapseOne"
                class="accordion-collapse collapse show"
                aria-labelledby="headingOne"
                data-bs-parent="#accordionExample"
              >
                <div class="accordion-body">
                  The benefits of this program are multi-faceted. Participants
                  gain access to a meticulously curated learning environment,
                  tailored to provide specialized knowledge and skills in
                  various domains
                </div>
              </div>
            </div>
            <div class="accordion-item">
              <h2 class="accordion-header" id="headingTwo">
                <button
                  class="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseTwo"
                  aria-expanded="false"
                  aria-controls="collapseTwo"
                >
                  How do I enroll in a course?
                </button>
              </h2>
              <div
                id="collapseTwo"
                class="accordion-collapse collapse"
                aria-labelledby="headingTwo"
                data-bs-parent="#accordionExample"
              >
                <div class="accordion-body">
                  To enroll to Vodafone Talent Academy courses, contact <a href="#"> #</a>
                </div>
              </div>
            </div>
            <div class="accordion-item">
              <h2 class="accordion-header" id="headingThree">
                <button
                  class="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseThree"
                  aria-expanded="false"
                  aria-controls="collapseThree"
                >
                  Can I interact with instructors or Vodafone SME's during the
                  course?
                </button>
              </h2>
              <div
                id="collapseThree"
                class="accordion-collapse collapse"
                aria-labelledby="headingThree"
                data-bs-parent="#accordionExample"
              >
                <div class="accordion-body">
                  Yes, Regular SME connects will be scheduled where the learners
                  can interact with SME's and get their queries answered. Viva
                  Engage will be created where you can interact with other
                  learners enrolled for this program
                </div>
              </div>
            </div>
            {/* <div class="accordion-item">
              <h2 class="accordion-header" id="headingFour">
                <button
                  class="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseFour"
                  aria-expanded="false"
                  aria-controls="collapseFour"
                >
                  Do I get participation certificate after completing the
                  training?
                </button>
              </h2>
              <div
                id="collapseFour"
                class="accordion-collapse collapse"
                aria-labelledby="headingFour"
                data-bs-parent="#accordionExample"
              >
                <div class="accordion-body">
                  Lorem ipsum dolor sit amet consectetur adipisicing elit. Eum
                  voluptatum quaerat nisi magnam? Officia commodi ipsum natus,
                  corrupti repellendus cumque quas aspernatur cum ducimus
                  voluptatum odit ipsam? Soluta, voluptatum vitae!
                </div>
              </div>
            </div> */}
            <div class="accordion-item">
              <h2 class="accordion-header" id="headingFive">
                <button
                  class="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseFive"
                  aria-expanded="false"
                  aria-controls="collapseFive"
                >
                  How long do I have access to a course after enrolling?
                </button>
              </h2>
              <div
                id="collapseFive"
                class="accordion-collapse collapse"
                aria-labelledby="headingFive"
                data-bs-parent="#accordionExample"
              >
                <div class="accordion-body">
                  For access issues and details contact
                  <a href="#"> #</a>
                </div>
              </div>
            </div>
            {/* <div class="accordion-item">
              <h2 class="accordion-header" id="headingSix">
                <button
                  class="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseSix"
                  aria-expanded="false"
                  aria-controls="collapseSix"
                >
                  Do I need to complete the course within the timeline?
                </button>
              </h2>
              <div
                id="collapseSix"
                class="accordion-collapse collapse"
                aria-labelledby="headingSix"
                data-bs-parent="#accordionExample"
              >
                <div class="accordion-body">
                  Lorem ipsum dolor sit amet consectetur adipisicing elit. Eum
                  voluptatum quaerat nisi magnam? Officia commodi ipsum natus,
                  corrupti repellendus cumque quas aspernatur cum ducimus
                  voluptatum odit ipsam? Soluta, voluptatum vitae!
                </div>
              </div>
            </div> */}
            <div class="accordion-item">
              <h2 class="accordion-header" id="headingSeven">
                <button
                  class="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseSeven"
                  aria-expanded="false"
                  aria-controls="collapseSeven"
                >
                  How do I contact support if I have questions or issues?
                </button>
              </h2>
              <div
                id="collapseSeven"
                class="accordion-collapse collapse"
                aria-labelledby="headingSeven"
                data-bs-parent="#accordionExample"
              >
                <div class="accordion-body">
                  For Vodafone Talent Academy Program related queries, reach out to{" "}
                  <a href="#"> #</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default FAQContent;
